import { jsx } from 'react/jsx-runtime';

var Tooltip = function (props) {
    return jsx("div", { className: props.className || '', children: props.children });
};

export { Tooltip as default };
//# sourceMappingURL=Tooltip.js.map
